export default {
    SET_CODES: (state, codes) => {
        state.codes = codes
    },

    SET_REFERRALS: (state, referrals) => {
        state.referrals = referrals
    },

    SET_LOAD: (state, isLoaded) => {
        state.isLoaded = isLoaded
    },

    SET_FILTERS: (state, filters) => {
        state.filters = filters
    },

    SET_PAGINATION: (state, pagination) => {
        state.pagination = pagination
    },

    RESET_REFERRALS: (state) => {
        state.filters = {
            business: null,
            referralCode: null,
            fromDate: new Date(+new Date() - 2419200000).toISOString().split('T')[0],
            toDate: new Date().toISOString().split('T')[0],
            clientId: null
        }
    }
}
